import { useTranslation } from 'react-i18next'
import { BriefingRequiredNextBanner } from '@/shared/briefing'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { EMC_BRIEFING_ID_PREFIX } from './constants'
import { toV2EmcBriefingStep } from './toV2EmcBriefingStep'

export function V2EmcRequiredNextBanner({
  firstIncompleteStep,
}: {
  firstIncompleteStep: EmcBriefingStep | null
}) {
  const { t } = useTranslation('common')

  const firstIncompleteStepWithLabels =
    firstIncompleteStep != null ? toV2EmcBriefingStep(firstIncompleteStep, t) : null

  let incompleteMessage = ''
  if (firstIncompleteStepWithLabels != null) {
    incompleteMessage = t(
      'v2.pages.products.detail.emcBriefing.requiredNext.stepMessage',
      {
        stepTitle: firstIncompleteStepWithLabels.title,
      }
    )
    if (firstIncompleteStep?.key === 'euDeclaration') {
      incompleteMessage = t(
        'v2.pages.products.detail.emcBriefing.requiredNext.blockedByDeclaration',
        { stepTitle: firstIncompleteStepWithLabels.title }
      )
    }
  }

  const goToStepLabel =
    firstIncompleteStepWithLabels != null
      ? t('v2.pages.products.detail.emcBriefing.requiredNext.goToStep', {
          stepTitle: firstIncompleteStepWithLabels.title,
        })
      : ''

  return (
    <BriefingRequiredNextBanner
      idPrefix={EMC_BRIEFING_ID_PREFIX}
      title={t('v2.pages.products.detail.emcBriefing.requiredNext.title')}
      allCompleteMessage={t(
        'v2.pages.products.detail.emcBriefing.requiredNext.allComplete'
      )}
      incompleteMessage={incompleteMessage}
      goToStepLabel={goToStepLabel}
      firstIncompleteStep={firstIncompleteStepWithLabels}
    />
  )
}
